import { loadWorkoutHistory } from '@/lib/analytics/queryItems'
import { communityApiClient } from '@/lib/api/lib/client'
import { getUserId } from '@/lib/cookies'
import { ownKey } from '@/lib/ownKey'
import { revalidatedQuery } from '@/lib/queryCache'

// Own data more than one screen reads: one key and one fetcher each, so
// the screens share a copy and a refresh.

/** Home's history section and the schedule list. */
export const workoutHistoryQuery = () =>
    revalidatedQuery(ownKey('workoutHistory'), () =>
        loadWorkoutHistory(getUserId())
    )

/** Home's request cards and the requests list. */
export const sentRequestsQuery = () =>
    revalidatedQuery(ownKey('requests:sent'), () =>
        communityApiClient.listRequests({})
    )

/** Home's coach dashboard and the requests list's coach tab. */
export const coachRequestsQuery = () =>
    revalidatedQuery(ownKey('requests:coach'), () =>
        communityApiClient.listRequests({ coachId: getUserId() })
    )
